exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".action-record-table .tip[data-v-2254abc4] {\n  padding: 15px;\n  border-radius: 10px;\n  line-height: 1.8;\n  background-color: #fef2f2;\n}\n", ""]);

// exports
